webpackJsonp([107233689102835],{

/***/ 852:
/***/ (function(module, exports) {

	module.exports = {"data":{"contributionsJson":{"name":"point of interest","www_url":"http://i-love-u.ch","thema":"points of interest","issue_month":"June","issue_year":2006,"issue_date":200606,"artist":"ruth","location":"Switzerland","email":"ruth@i-love-u.ch","id":"contribution_207","media_type":"still_image","position_in_section":2,"media_uri":"media/2006/June/still_image/point01.jpg","media_th_uri":"media/2006/June/still_image/tn_point01.jpg","still_image_count":5,"moving_image_count":1,"textz_count":1,"soundz_count":0}},"pathContext":{"id":"contribution_207"}}

/***/ })

});


// WEBPACK FOOTER //
// path---issue-200606-still-image-2-8b37d6b87ee0ec477621.js